import React from "react";
import { StyleSheet, css } from "aphrodite";

export default function CoreValues(){
    const styles = StyleSheet.create({

        mainContainerStyle: {
            width: '100%',
            display: 'flex',
            justifyContent: ' center',
            alignItems: 'center',
            backgroundColor: '#F0EFEC',
            padding: '2rem 0',
            "@media (min-width: 1024px)": {
                padding: '5rem 0',
            }
        },
        valueContainerStyle: {
            width: '80%',
            backgroundColor: '#011a39',
            borderRadius: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: ' center',
            alignItems: 'center',
            padding: '5%',
            "@media (min-width: 1024px)": {
                padding: '5% 0',
            }
        },
        titleStyle: {
            color: '#fec803',
            fontFamily: 'Oswald',
            fontStyle: "bold",
            fontSize: "3rem",
            textAlign: "center",
        },
        liStyle: {
            color: '#F0EFEC',
            fontFamily: "Montserrat",
            fontSize: "1.2rem",
        },
        coreValuesResumedStyle: {
            color: '#F0EFEC',
            fontFamily: "Montserrat",
            width: '100%',
            "@media (min-width: 1024px)": {
                width: '60%',
            }
        }
    })
    return(
        <>
            <div className={css(styles.mainContainerStyle)}>
                <div className={css(styles.valueContainerStyle)}>
                    <div className={css(styles.titleStyle)}>OUR CORE VALUES</div>
                    <ul>
                        <li className={css(styles.liStyle)}>Quality Craftsmanship</li>
                        <li className={css(styles.liStyle)}>Customer-Centric Approach</li>
                        <li className={css(styles.liStyle)}>Innovation & Engineering Excellence</li>
                        <li className={css(styles.liStyle)}>Integrity & Transparency</li>
                        <li className={css(styles.liStyle)}>Sustainability & Responsibility</li>
                        <li className={css(styles.liStyle)}>Safety & Reliability</li>
                    </ul>
                    <div className={css(styles.coreValuesResumedStyle)}>At JF Welding, our core values are built on a foundation of quality craftsmanship, ensuring every trailer is durable and reliable. We put our customers first, offering personalized solutions and exceptional service. We embrace innovation and engineering excellence to stay ahead of industry needs, while upholding integrity and transparency in every aspect of our business. We are committed to sustainability, using eco-friendly materials and practices, and prioritize safety and reliability in all our products to ensure the utmost protection for our customers and their cargo.</div>
                </div>
            </div>
        </>
    )
}